import React from 'react';
import withStyles, { type WithStyles } from '@material-ui/core/styles/withStyles';
import createStyles from '@material-ui/styles/createStyles';
import classNames from 'classnames';
import { colors } from '../../theme';

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const styles = () =>
  createStyles({
    wrapper: {
      display: 'flex',
    },
    square: {
      height: '16px',
      width: '18px',
      lineHeight: '16px',
      position: 'relative',
      backgroundColor: colors.lightGreyBlue,
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
    },
    squareBlue: {
      backgroundColor: colors.bluePrimary,
      color: '#ffffff',
    },
    squareGreen: {
      backgroundColor: colors.green,
      color: '#ffffff',
    },
    squareTeal: {
      backgroundColor: colors.teal,
      color: '#ffffff',
    },
    triangle: {
      borderColor: `transparent transparent transparent ${colors.lightGreyBlue}`,
      borderStyle: 'solid',
      borderWidth: '8px 0 8px 8px',
    },
    triangleBlue: {
      borderLeftColor: colors.bluePrimary,
    },
    triangleGreen: {
      borderLeftColor: colors.green,
    },
    triangleTeal: {
      borderLeftColor: colors.teal,
    },
  });

interface ITagProps extends WithStyles<typeof styles> {
  color?: 'green' | 'blue' | 'teal';
  children?: any;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const Tag = (props: ITagProps) => {
  return (
    <div className={props.classes.wrapper}>
      <div
        className={classNames(props.classes.square, {
          [props.classes.squareBlue]: props.color === 'blue',
          [props.classes.squareGreen]: props.color === 'green',
          [props.classes.squareTeal]: props.color === 'teal',
        })}
      >
        {props.children}
      </div>
      <div
        className={classNames(props.classes.triangle, {
          [props.classes.triangleBlue]: props.color === 'blue',
          [props.classes.triangleGreen]: props.color === 'green',
          [props.classes.triangleTeal]: props.color === 'teal',
        })}
      />
    </div>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default withStyles(styles)(Tag);
